import { Component, OnInit, EventEmitter, Output, ViewEncapsulation, Input } from '@angular/core';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { ReincidenciaOcorrencia } from '../../comum/modelos/reincidencia-ocorrencia';

@Component({
    selector: 'app-modal-reincidencia-ocorrencia',
    templateUrl: './modal-reincidencia-ocorrencia.component.html',
    encapsulation: ViewEncapsulation.None,
    styleUrls: ['./modal-reincidencia-ocorrencia.component.css']
})
export class ModalReincidenciaOcorrenciaComponent implements OnInit {

    @Output() reincidenciaOcorrenciaEvent: EventEmitter<ReincidenciaOcorrencia>;
    @Input() idConfigOcorrenciaAuto: number;
    @Input() origem: string;
    public reincidenciaOcorrencia: ReincidenciaOcorrencia;

    constructor(private modalService: NgbModal) {
        this.reincidenciaOcorrenciaEvent = new EventEmitter<ReincidenciaOcorrencia>();
        this.reincidenciaOcorrencia = new ReincidenciaOcorrencia();
    }

    cadastrar(content) {
        const ngbModalOptions: NgbModalOptions = {
            backdrop: 'static',
            keyboard: false,
            windowClass: 'modalReincidenciaOcorrencia',
            size: 'lg'
        };
        this.modalService.open(content, ngbModalOptions).result.then((result) => {
            this.reincidenciaOcorrencia = result;
            this.reincidenciaOcorrenciaEvent.emit(this.reincidenciaOcorrencia);
        }, (reason) => {
        });
    }

    ngOnInit() {
    }

}



// WEBPACK FOOTER //
// C:/Development/Projects/Sun/Flag/workspace/flagvarejoang4/src/app/ocorrencias/modal-reincidencia-ocorrencia/modal-reincidencia-ocorrencia.component.ts